export default {
    company: {
        name: "Yibin Paper Industry Co., Ltd."
    },
    nav: {
        home: "Laman Utama",
        about: "Perihal Kami",
        products: "Hab Produk",
        contact: "Hubungi Kami",
        sustainability: "Kelestarian",
        technology: "Inovasi Teknologi"
    },
    banner: {
        title: "Bamboo Rhythm™: Kertas Elegan · Masa Depan Hijau",
        subtitle: "Mewarisi Seni Pembuatan Kertas Milenia, Memacu Standard Baharu Industri Pulpa Buluh"
    },
    products: {
        subtitle: "Produk Kertas Pulpa Buluh Premium, Memenuhi Kepelbagaian Keperluan",
        description: "Penyelesaian Produk Kertas Komprehensif, daripada Kertas Asas hingga Produk Siap untuk Semua Keperluan Anda",
        viewDetails: "Terokai Selengkapnya",
        categories: {
            title: "Siri Produk",
            subtitle: "Produk Kertas Buluh, Memacu Gaya Penggunaan Hijau",
            livingPaper: "Kertas Asas Kegunaan Harian",
            livingPaperDesc: "Siri Kertas Asas Kegunaan Harian",
            foodPaper: "Kertas Asas Pembungkusan Makanan",
            foodPaperDesc: "Siri Kertas Asas Pembungkusan Makanan",
            finishedProducts: "Siri Produk Siap Kegunaan Harian"
        },
        advantages: {
            title: "Kelebihan Produk",
            subtitle: "Menghidupkan Semula Kehidupan dengan Kekuatan Buluh"
        },
        applications: {
            title: "Bidang Aplikasi",
            subtitle: "Diaplikasikan Secara Meluas dalam Kehidupan Harian dan Pelbagai Industri"
        },
        cta: {
            title: "Perlukan Penyelesaian Produk Tersuai?",
            description: "Perkhidmatan Penyesuaian Produk Kertas Buluh Profesional Berdasarkan Keperluan Anda",
            buttonText: "Hubungi Kami"
        },
        detail: {
            features: 'Ciri Produk',
            contactUs: 'Hubungi Kami',
            specifications: 'Spesifikasi Produk',
            usageScenarios: 'Senario Penggunaan',
            relatedProducts: 'Produk Berkaitan',
            cta: {
                title: 'Perlukan Maklumat Produk Lanjut?',
                description: 'Perunding Produk Kami Sedia Memberi Nasihat Profesional dan Penyelesaian Tersuai',
                buttonText: 'Hubungi Kami'
            }
        },
        title: "Produk Utama"
    },
    advantages: {
        title: "Keunggulan Kami",
        subtitle: "Pembuatan Kertas Buluh, Teknologi Mesra Alam, Kualiti Unggul",
        items: {
            experience: {
                title: "Pengalaman Industri yang Mendalam",
                description: "80 Tahun Pengalaman Teknikal, Rantaian Industri Penuh Bersepadu, Menyokong Transformasi Bahan Bio-Berasaskan Karbon Rendah."
            },
            production: {
                title: "Sistem Pengeluaran Skala Besar Matang",
                description: "Kemudahan Pengeluaran & Talian Automasi Lengkap, Responsif terhadap Keperluan Pelanggan, Pengeluaran Berkos Rendah & Berkecekapan Tinggi."
            },
            innovation: {
                title: "Kerjasama Penyelidikan Industri-Akademi",
                description: "Makmal Bersama dengan Institusi Pengajian Tinggi, Fokus pada Teknologi Karbon Rendah & Bahan Boleh Diperbaharui, Mempercepat Pengkomersialan Teknologi Bio-Berasaskan."
            },
            certification: {
                title: "Pensijilan Hijau Rantaian Penuh",
                description: "Pensijilan FSC, Gred Perubatan, Keselamatan Kesihatan dari Sumber hingga Produk, Meningkatkan Daya Saing Pasaran."
            }
        }
    },
    footer: {
        contact: "Hubungi Kami",
        address: "Alamat: Yibin Paper Industry, Kawasan Perindustrian Ringan Peishi, Daerah Nanxi, Yibin, Sichuan",
        phone: "Tel: 0831-3309663",
        email: "E-mel:ybzy@yb-zy.com",
        quickLinks: "Pautan Pantas",
        moreInfo: "Maklumat Lanjut",
        news: "Berita & Kemas Kini",
        careers: "Kerjaya",
        informations:"Pendedahan Maklumat",
        followUs: "Ikuti Kami",
        wechat: "WeChat: Yibin Paper Industry",
        rights: "Hak Cipta Terpelihara",
        slogan: "Pembuatan Kertas Buluh, Inovasi Hijau",
        ICPfiling: "蜀ICP备05027078号-1",
        PublicSecurityFiling: "川公网安备51150302000130号"
    },
    about: {
        companyProfile: "Profil Syarikat",
        established: "Diasaskan pada 1944",
        formerName: `Bekas "Kilang Kertas China"`,
        firstNewsprint: "Tempat Kelahiran Kertas Akar Mesin Buatan China Pertama",
        listed: "Disenaraikan di Bursa Saham Shanghai (Kod: 600793) pada 1997",
        firstListed: "Syarikat Pembuatan Kertas Pertama Disenaraikan di China",
        firstYibinListed: "Syarikat Pertama Disenaraikan di Yibin",
        wuliangyeSubsidiary: "Anak Syarikat Wuliangye Group",
        firstNewMeterial: `Peneraju Rantaian Produk Baharu Buluh "60+10"`,
        capacity: "Kapasiti Pengeluaran",
        mainCapacity: "Kapasiti Pulpa & Kertas Ibu Pejabat: 540,000 tan setahun",
        managedCapacity: "Kapasiti Pulpa & Kertas Syarikat Diurus: 120,000 tan setahun",
        newMaterialCapacity: "Kapasiti Kotak Bergelombang Bahan Baharu: 100 juta m² setahun",
        bambooMoldingCapacity: "Kapasiti Acuan Pulpa Buluh Baharu: 6,600 tan setahun",
        celluloseCapacity: "Kapasiti Selulosa Asetat: 30,000 tan setahun",
        historyTitle: "Sejarah Perkembangan",
        historySubtitle: "70+ Tahun Membina Jenama Kertas Buluh",
        historyItems: {
            "1944": "Penubuhan Kilang Kertas China, Permulaan Sejarah Industri Kertas China",
            "1945": "Menghasilkan Kertas Akar Mesin Kayu 100% Pertama China",
            "1950": `Kilang Kertas China Ditukar Nama kepada "Kilang Kertas Yibin"`,
            "1961": "Lawatan Pengerusi Zhu De",
            "1966": "Lawatan Marshal Peng Dehuai",
            "1988": "Percubaan Sistem Saham, Penubuhan 'Yibin Paper Industry Co., Ltd.'",
            "1997": "Penyenaraian di Bursa Saham Shanghai",
            "2012": "Pembukaan Tapak Penempatan Semula Yibin Paper Industry",
            "2015": "Pembukaan Talian Pengeluaran Kertas Pembungkusan Makanan Zon Baharu",
            "2018_1": "Pembukaan Talian Pengeluaran Kertas Kegunaan Harian Zon Baharu",
            "2018_2": "Pengambilalihan oleh Wuliangye Group",
            "2025": "Permulaan Transformasi Menuju Kumpulan Bahan Bio-Berasaskan Khas"
        },
        futureDevelopment: "Masa Depan",
        future: {
            point1: "Fokus pada Matlamat Pembangunan",
            point2: "Memaksimumkan Kelebihan Sumber Buluh",
            point3: "Pecutan Transformasi ke Pengekhususan, Teknologi Tinggi & Nilai Tambah Tinggi",
            point4: "Membangunkan Juara Kecil Dunia dalam Segmen Industri Kertas"
        },
        coreValues: "Falsafah Perusahaan",
        coreValuesSubtitle: "Buluh sebagai Asas, Kertas sebagai Inti, Inovasi Hijau Memacu Pembangunan",
        values: {
            mission: "Misi Perusahaan",
            missionLine1: "Berdasarkan Bahan Bio-Baharu",
            missionLine2: "Mewujudkan Dunia Hijau Karbon Rendah",
            vision: "Wawasan Perusahaan",
            visionLine1: "Membangunkan Bahan Bio-Berasaskan Khas Hijau",
            visionLine2: "Kumpulan Industri Bahan Bersepadu",
            coreValues: "Nilai Teras",
            coreValuesLine1: "Kualiti Pertama, Didorong Inovasi",
            coreValuesLine2: "Pembangunan Hijau, Menang Bersama",
            philosophy: "Falsafah Pengurusan",
            philosophyLine1: "Berfokuskan Pelanggan",
            philosophyLine2: "Berkualiti sebagai Asas, Inovatif sebagai Pendorong"
        },
        certificationsTitle: "Pensijilan",
        certificationsSubtitle: "Jaminan Kualiti, Diiktiraf Industri",
        certificationItems: {
            fsc: "Pensijilan Hutan Antarabangsa",
            fscDesc: "Pensijilan Hutan Antarabangsa, Bahan Mentah daripada Sumber Bertanggungjawab",
            iso9001: "Pensijilan ISO9001",
            iso9001Desc: "Sijil Sistem Pengurusan Kualiti Antarabangsa",
            iso14001: "Pensijilan FSSC22000",
            iso14001Desc: "Sijil Sistem Keselamatan Makanan",
            medical: "Pensijilan Produk Gred Perubatan",
            medicalDesc: "Sijil Produk Gred Perubatan",
            antibacterial: "Pensijilan Kebersihan Antibakteria",
            antibacterialDesc: "Sijil Kebersihan Antibakteria",
            safety: "Pensijilan Produk Selamat Bersih",
            safetyDesc: "Sijil Produk Selamat Bersih"
        },
        honorsTitle: "Anugerah Syarikat",
        honorsSubtitle: "Jaminan Kualiti, Diiktiraf Industri",
        honorItems: {
            greenFactory: "Kilang Hijau Kebangsaan",
            greenFactoryDesc: "Peneraju Pembuatan Hijau oleh MIIT China",
            forestryLeader: "Peneraju Utama Perhutanan Kebangsaan",
            forestryLeaderDesc: "Peneraju Utama oleh Pentadbiran Perhutanan & Padang Rumput China",
            agriculturalProduct: "Perniagaan Hasil Pertanian Cemerlang China",
            agriculturalProductDesc: "Jenama Hasil Pertanian Cemerlang China",
            lightIndustry: "Pasukan Industri Ringan Cemerlang Kebangsaan",
            lightIndustryDesc: "Pasukan Industri Ringan Cemerlang Kebangsaan",
            bambooProduct: "10 Syarikat Produk Buluh Terkemuka",
            bambooProductDesc: "10 Jenama Industri Buluh Teratas China",
            engineeringCenter: "Pusat Penyelidikan Kejuruteraan Kertas",
            engineeringCenterDesc: "Pusat Kejuruteraan Pulpa & Kertas Buluh Sichuan"
        },
        productHonorsTitle: "Anugerah Produk",
        productHonorsSubtitle: "Jaminan Kualiti, Diiktiraf Industri",
        productHonorItems: {
            industryExcellence: "Produk Kraf Industri",
            neZhaExcellence: "Siri Nezha: Produk Kraf Industri Kertas Kegunaan Harian China 2025",
            moDiKaExcellence: "Siri Merdeka: Produk Kraf Industri Kertas Kegunaan Harian China",
            bambooExpoGold: "Emas Pameran Buluh Antarabangsa",
            moDiKaGold: "Siri Merdeka: Emas Pameran Buluh Antarabangsa 2025",
            shanghaiExpoGold: "Emas Pameran Buluh Antarabangsa",
            jinZhuGold: "Siri Golden Bamboo: Emas Pameran Buluh Shanghai 2020",
            quanZhuGold: "Kertas Pembungkusan Buluh Penuh: Emas Pameran Buluh Shanghai 2018",
            westernExpoGold: "Emas Pameran Industri Perhutanan Barat China",
            jinZhuWesternGold: "Siri Golden Bamboo: Emas Pameran Industri Perhutanan Barat China"
        },
        cta: {
            title: "Menyertai Yibin Paper, Membina Masa Depan Hijau Bersama",
            description: "Kami Berharap Bekerjasama dengan Anda untuk Memacu Pembangunan Lestari Industri Kertas Pulpa Buluh",
            buttonText: "Hubungi Kami"
        }
    },
    technology: {
        title: 'Inovasi Teknologi',
        subtitle: 'Dipandu Sains, Direvolusi Hijau, Mencipta Piawaian Baharu Industri Kertas Pulpa Buluh',
        innovation: {
            title: 'Pembangunan Dipacu Inovasi',
            subtitle: 'Dipandu Sains, Direvolusi Hijau, Mencipta Piawaian Baharu Industri Kertas Pulpa Buluh',
            management: {
                title: 'Sistem Pengurusan Inovasi Beroperasi Secara Efisien dan Bersepadu',
                content: "Yibin Paper Industry sentiasa menganggap inovasi teknologi sebagai teras pembangunan perusahaan. Syarikat menubuhkan Jawatankuasa Strategi dan Pembangunan untuk menyelaraskan tiga paksi utama: R&D, pengeluaran, dan pemasaran. Struktur inovasi 'Jabatan R&D Teknologi Ibu Pejabat + Tapak Pengeluaran' dibangunkan dengan mekanisme insentif fleksibel, memastikan pelaksanaan efisien dari inovasi teknologi sehingga perindustrian."
            },
            team: {
                title: 'Pasukan Profesional Memacu Kejayaan Teknologi',
                content: 'Berdasarkan Platform Inovasi Wilayah dan Pasukan R&D, Bekerjasama Rapat dengan Pelbagai Institusi Pengajian Tinggi dan Penyelidikan Terkemuka, Memfokuskan Projek R&D dalam Bidang Pulping Karbon Rendah dan Bahan Bio-Berasaskan, Menyediakan Tenaga Penggerak untuk Inovasi Perusahaan'
            },
            results: {
                title: 'Pencapaian Inovasi Memacu Naik Taraf Industri',
                content: 'Menguasai Teknologi Teras Rantaian Penuh Pembuatan Kertas Pulpa Buluh, Terus Mencapai Kejayaan dalam Pulping Hijau, Pengeluaran Bersih dan Pemanfaatan Sumber Secara Menyeluruh melalui Inovasi Teknologi, Memimpin Transformasi Perusahaan ke Industri Bahan Bio-Berasaskan Karbon Rendah Hijau'
            }
        },
        core: {
            title: 'Teknologi Teras',
            subtitle: 'Dipandu Sains, Inovasi Hijau',
            tabs: {
                pulping: 'Teknologi Pulping Buluh',
                bleaching: 'Teknologi Teras Ekonomi Kitaran',
                papermaking: 'Inovasi Teknologi Produk Hijau'
            },
            items: {
                pulping: {
                    details: [
                        {
                            title: 'Sistem Teknologi Pra-Pemprosesan Buluh',
                            content: 'Mengatasi Cabaran Pemprosesan Ketumpatan Tinggi dan Kandungan Silika Tinggi Buluh, Membangunkan Teknologi Rendaman Seragam Buluh, Mengurangkan Penggunaan Tenaga >10%'
                        },
                        {
                            title: 'Teknologi Pulping Bersih Karbon Rendah',
                            content: 'Proses "Delignifikasi Mendalam-Pelunturan ECF" Bersepadu, Pelepasan AOX 30% Lebih Rendah Daripada Piawaian Negara; Teknologi Rawatan Air "Anaerob+Aerob+Fenton" Bersepadu, Pelepasan COD 50% Lebih Rendah Daripada Piawaian Negara'
                        }
                    ]
                },
                bleaching: {
                    details: [
                        {
                            title: 'Teknologi Pemanfaatan Penuh Komponen Buluh',
                            content: 'Selulosa Buluh untuk Pulping dan Pembuatan Kertas; Lignin Cecair Hitam Dibakar untuk Memulihkan Tenaga Haba, Menjana 350kWh per Tan Pulpa; Sisa Pulping Diproses Menjadi Baja Bio untuk Alam Semula Jadi'
                        }
                    ]
                },
                papermaking: {
                    details: [
                        {
                            title: 'Produk Gentian Buluh Berfungsi',
                            content: 'Teknologi Pengukuhan Gentian Buluh, Meningkatkan Kekuatan Tegangan dan Lenturan Kertas Pembungkusan >50%, Memberi Prestasi Produk Lebih Baik; Membangunkan Produk Kertas Kegunaan Harian Antibakteria Sendiri, Menggunakan Komponen Antibakteria Semula Jadi Buluh, Meningkatkan Kecekapan Antibakteria >90% dalam Keadaan Sama'
                        },
                        {
                            title: 'Bahan Baharu Bio-Berasaskan',
                            content: 'Produk Gentian Buluh Menggantikan Produk Plastik, Mengurangkan Jejak Karbon 60%'
                        }
                    ]
                }
            }
        },
        research: {
            title: 'Pusat R&D',
            subtitle: 'Fokus pada R&D, Mencipta Nilai',
            imageAlt: 'Pusat R&D Yibin Paper',
            center: {
                title: 'Platform Inovasi R&D',
                content: 'Pusat R&D Diasaskan pada 2003, Jabatan Teras Inovasi Teknologi Syarikat, Memfokuskan Trend Industri dan Memacu Transformasi Keputusan Teknologi. Syarikat kini Pusat Teknologi Perusahaan Wilayah, Memiliki Pusat Kejuruteraan Pulpa & Kertas Buluh Sichuan. Memimpin Penubuhan "Komuniti Penyepaduan Industri-Pendidikan Industri Buluh Baharu" dan Menyertai Projek Khas Negara "Penyelidikan Teknologi Kunci Penyepaduan Pulpa-Kertas Buluh". Mengumpulkan Pengalaman Kaya dalam Teknologi Kunci Pengeluaran Kertas Pulpa Buluh, Membentuk Kelebihan Daya Saing Teknologi'
            },
            cooperation: {
                title: 'R&D Kolaboratif',
                content: 'Pusat Menjalin Kerjasama Jangka Panjang dengan Universiti Pertanian Sichuan, Universiti Teknologi China Selatan, Universiti Perhutanan Beijing, Universiti Perhutanan Nanjing, Akademi Penyelidikan Perhutanan China, dll., Menyertai Projek Penyelidikan Negara dan Wilayah, Memacu Penyepaduan Mendalam Industri-Akademi-Penyelidikan'
            }
        },
        patents: {
            title: 'Paten & Pencapaian',
            subtitle: 'Pengumpulan Teknologi, Peneraju Industri',
            authorized: {
                title: 'Paten Berlesen',
                items: [
                    'Pulpa Buluh Campuran Tersuling, Kaedah Penyediaannya dan Aplikasi dalam Pembuatan Kertas',
                    'Pulpa Buluh Tersuling, Kaedah Penyediaannya dan Aplikasi dalam Pembuatan Kertas',
                    'Muncung Semburan Cecair Hitam untuk Relau Pemulihan Alkali',
                    'Peranti Penyaring Gentian'
                ]
            },
            projects: {
                title: 'Projek Penyelidikan',
                items: [
                    'Penyelidikan Teknologi Pembuatan Pulpa Buluh Ketumpatan/Kekuatan Tinggi Bersih dan Teknologi Pembentukan Papan Pembungkusan Berkekuatan Tinggi',
                    'Penyelidikan Teknologi Pemurnian Pulpa Kimia Buluh dan Pembentukan Kertas Kegunaan Harian Premium',
                    'Penyelidikan dan Pembangunan Teknologi Pemprosesan Mendalam Pulpa Berasaskan Buluh',
                    'Penyelidikan dan Pembangunan Gentian Selulosa Berkualiti Tinggi Berasaskan Buluh',
                    'Penyelidikan dan Pembangunan Produk Bernilai Tinggi Lignin Berfungsi'
                ]
            },
            awards: {
                title: 'Anugerah Sains',
                items: [
                    'Anugerah Kemajuan Sains & Teknologi Kelas Pertama Sichuan'
                ]
            },
            papers: {
                title: 'Kertas Kajian',
                items: [
                    'Penentuan Jumlah Rosin dan Kandungan Aluminium Sulfat dalam Gam Rosin Terdispersi Kation',
                    'Percubaan Pembuatan Kad Makanan Warna Asli dengan Pulpa Kimia-Mekanikal Buluh',
                    'Aplikasi Bantu Masak dalam Proses Masak DDS Buluh Penuh',
                    'Proses Baharu untuk Pemanfaatan Cekap Sumber Gentian Buluh dalam Pengeluaran Pulpa Larut melalui Penggredan Gentian: Kajian Makmal dan Ujian Kilang',
                    'Strategi Penyahgabungan Bersiri Kaviti Ultrasonik untuk Pemanfaatan Bernilai Tinggi Lignin'
                ]
            }
        },
        projects: {
            title: 'Projek Inovasi',
            subtitle: 'Memacu Hala Tuju Industri Masa Depan',
            items: [
                {
                    title: 'Penyepaduan Teknologi Kunci & Kilang Demonstrasi Rantaian Industri Buluh Sichuan',
                    period: '2019-2022',
                    cooperation: 'Universiti Pertanian Sichuan',
                    desc: 'Menyepadukan Rantaian Sumber dan Industri Buluh Secara Organik, Memacu Pembangunan Industri Buluh'
                },
                {
                    title: 'Pembinaan dan Demonstrasi Platform Inovasi Teknologi Tinggi Industri Buluh Yibin',
                    period: '2019-2022',
                    cooperation: 'Universiti Teknologi China Selatan',
                    desc: 'Mencapai Kejayaan dalam Teknologi Masak Sulfur Rendah Buluh dan Teknologi Pemanfaatan Bernilai Tinggi Cecair Hitam'
                },
                {
                    title: 'Penyelidikan dan Pembangunan Teknologi Pemprosesan Mendalam Pulpa Berasaskan Buluh',
                    period: '2022-2024',
                    cooperation: 'Akademi Sains Perhutanan China',
                    desc: 'Mengatasi Teknologi Kunci seperti Pulping Hasil Tinggi Buluh, Melaksanakan Penggunaan Perindustrian, Mencapai Penggantian Import Bahan Mentah'
                },
                {
                    title: 'Penyelidikan dan Pembangunan Produk Bernilai Tinggi Lignin Berfungsi',
                    period: '2022-2024',
                    cooperation: 'Universiti Perhutanan Beijing',
                    desc: 'Mengekstrak Komponen Lignin Secara Bergredan daripada Cecair Hitam Pulping Buluh untuk Menyediakan Produk Sampingan, Mengatasi Kaedah Pemanfaatan Bernilai Tinggi Cecair Hitam'
                },
                {
                    title: 'Penyelidikan Teknologi Kunci Penyepaduan Pulpa-Kertas Buluh',
                    period: '2023-2028',
                    cooperation: 'Akademi Sains Perhutanan China',
                    desc: 'Teknologi Kunci termasuk Rendaman Homogen Cekap, Pengisaran Tenaga Berjimat dengan Pemisahan Tepat, Pelunturan Pengaktifan Hidrogen Peroksida Beralkali'
                },
                {
                    title: 'Penyelidikan dan Demonstrasi Bersepadu Teknologi Kunci Industri Buluh Pintar',
                    period: '2024-2027',
                    cooperation: 'Universiti Perhutanan Nanjing',
                    desc: 'Menjalankan Kajian mengenai Cabaran Teknologi Kunci termasuk Pembuatan Bersih Perusahaan Kertas Pulpa Buluh dan Pemanfaatan Sumber Menyeluruh'
                }
            ]
        },
        cta: {
            title: 'Jelajah Masa Depan Kertas Pulpa Buluh Bersama',
            subtitle: 'Mengalu-alukan Rakan yang Berminat dengan Inovasi Teknologi Kertas Pulpa Buluh untuk Menghubungi Kami, Memacu Pembangunan Industri Bersama',
            button: 'Hubungi Kami'
        }
    },
    sustainability: {
        title: 'Pembangunan Lestari',
        subtitle: 'Berdasarkan Buluh, Berinkuasi, Membina Piawai Industri Bahan Bio-Berasaskan Hijau Karbon Rendah',
        vision: {
            title: 'Wawasan Pembangunan Lestari',
            content: 'Berdasarkan Buluh, Berinkuasi, Membina Piawai Industri Bahan Bio-Berasaskan Hijau Karbon Rendah',
            imageAlt: 'Wawasan Pembangunan Lestari Yibin Paper',
            intro1: 'Sebagai Inovator Industri Pembuatan Kertas Pulpa Buluh,',
            intro2: 'Yibin Paper Berpegang pada "Pemanfaatan Cekap Sumber Buluh + Teknologi Karbon Rendah" sebagai Teras, Memacu Transformasi Industri Tradisional ke Arah Kehijauan, Bernilai Tinggi dan Kitaran',
            items: {
                circular: {
                    title: 'Hijau Karbon Rendah, Memacu Ekonomi Kitaran',
                    content: 'Berdasarkan Sifat Buluh Boleh Diperbaharui, Tumbuh Cepat dan Penyerapan Karbon, Membina Rantaian Industri Penuh "Sumber Buluh - Pulping Bersih - Bahan Bio-Berasaskan - Produk Karbon Rendah", Mencapai "Sisa Sifar, Pemanfaatan Penuh", Menyokong Sasaran "Dual Karbon" 30/60'
                },
                innovation: {
                    title: 'Inovasi Sains & Teknologi Memacu Transformasi Bernilai Tinggi',
                    content: 'Mengatasi Teknologi Pemanfaatan Bernilai Tinggi Gentian Buluh, Membangunkan Produk Baharu Pengganti Plastik seperti Pembungkusan Boleh Terurai dan Komposit Bio-Berasaskan, Mengurangkan Jejak Karbon Sepanjang Kitaran Hidup'
                },
                rural: {
                    title: 'Kemenangan Ekologi, Memperkasa Pembangunan Desa',
                    content: 'Melalui Model "Pangkalan Buluh + Kilang Hijau + Simbiosis Komuniti", Meningkatkan Pendapatan Karbon Buluh, Memacu Pembangunan Bersepadu Hulu-Hilir Rantaian Industri, Mencapai Kesatuan Faedah Persekitaran, Ekonomi dan Sosial'
                },
                cooperation: {
                    title: 'Kerjasama Terbuka, Membina Masa Depan Lestari Bersama',
                    content: 'Bersama Institusi Penyelidikan dan Rakan Rantaian Industri, Memacu Penetapan Piawaian dan Pengaplikasian Teknologi Bahan Berasaskan Buluh, Menjadikan "Gantikan Plastik dengan Buluh, Gantikan Kayu dengan Buluh" Penyelesaian Hijau Global'
                }
            },
            commitment: {
                title: 'Komitmen Kami:',
                content: 'Setiap Batang Buluh adalah Simbiosis Alam dan Teknologi; Setiap Inovasi adalah untuk Masa Depan Bumi dan Manusia'
            }
        },
        cleanProduction: {
            title: 'Pengeluaran Bersih',
            subtitle: 'Melindungi Alam dengan Teknologi Inovasi, Memacu Pembangunan Lestari melalui Pengeluaran Bersih',
            description: 'Sebagai Perintis Hijau Industri Pembuatan Kertas Pulpa Buluh, Yibin Paper Sentiasa Mengamalkan Falsafah "Keutamaan Alam Sekitar, Pembangunan Hijau", melalui Proses Pengeluaran Bersih, Kitar Semula Sumber dan Inovasi Teknologi Karbon Rendah, Membina Industri Kertas Moden Cekap, Bersih dan Lestari, Menyediakan Penyelesaian Kertas Hijau untuk Pelanggan Global',
            items: {
                raw: {
                    title: 'Bahan Mentah Hijau, Sumber Karbon Rendah',
                    subtitle: '100% Gentian Buluh Lestari, Sisa Pengeluaran Dimanfaatkan Secara Menyeluruh',
                    points: [
                        'Menggunakan Sumber Buluh Tumbuh Cepat, Mengurangkan Penebangan Hutan',
                        'Proses Tumbesaran Buluh Mempunyai Keupayaan Penyerapan Karbon Tinggi, Mengurangkan Pelepasan Karbon dari Sumber',
                        'Meneroka Kaedah Pemanfaatan Menyeluruh Sisa Pengeluaran seperti Serpihan Buluh dan Lumpur Putih, Mencapai Kitaran Sumber Cekap'
                    ]
                },
                process: {
                    title: 'Proses Bersih, Jimat Tenaga dan Kurangkan Penggunaan',
                    subtitle: 'Teknologi Pulping Pencemaran Rendah, Pelepasan Air Sisa dan Gas Buang Ultra Rendah',
                    points: [
                        'Menggunakan Proses Maju seperti Pelunturan Bebas Klorin Unsur (ECF) dan Penyahliginan Oksigen, Mengurangkan Pelepasan Bahan Berbahaya seperti AOX (Halogen Organik Bolehjerap) Secara Bererti',
                        'Gabungan Teknologi termasuk Rawatan Biologi Aerobik, Mencapai Pelepasan Air Sisa Mematuhi Piawaian, Mengitar Semula Air Terawat untuk Mencuci Bahan Mentah, Mengurangkan Penggunaan Air Segar',
                        'Dilengkapi Sistem Relau Pemulihan Alkali + Penyingkiran Habuk Elektrostatik + Penyahsulfur Basah, Memastikan Pelepasan Gas Buang Melebihi Piawaian Negara'
                    ]
                },
                recycle: {
                    title: 'Ekonomi Kitaran, Tukar Sisa menjadi Sumber',
                    subtitle: 'Cecair Hitam 100% Dikitar Semula, Enap Cemar Dijadikan Sumber, Haba Lebihan Digunakan Semula',
                    points: [
                        'Cecair Sisa Pulping Ditukar menjadi Tenaga Haba dan Bahan Kimia melalui Sistem Pemulihan Alkali, Kadar Keperluan Sendiri >85%, Mengurangkan Kebergantungan pada Tenaga Fosil',
                        'Enap Cemar Kertas Digunakan untuk Menghasilkan Baja Organik atau Bahan Bakar Biojisim, Mencapai "Sifar Pelupusan" Sisa Pepejal',
                        'Haba Lebihan dalam Proses Pengeluaran Digunakan untuk Penjanaan Kuasa, Meningkatkan Kecekapan Penggunaan Tenaga'
                    ]
                },
                product: {
                    title: 'Produk Hijau, Kehidupan Karbon Rendah',
                    subtitle: 'Kertas Pembungkusan Boleh Terurai, Produk Bersijil FSC',
                    points: [
                        'Kertas Pembungkusan Gred Makanan Gentian Buluh, Menggantikan Produk Plastik, Mengurangkan "Pencemaran Putih"',
                        'Memastikan Sumber Kertas Mematuhi Piawaian Pengurusan Hutan Lestari Antarabangsa, Memenuhi Keperluan Pasaran Premium'
                    ]
                }
            }
        },
        circularEconomy: {
            title: 'Ekonomi Kitaran',
            subtitle: 'Buluh Dimanfaatkan Sepenuhnya, Berkekalan Tanpa Henti',
            imageAlt: 'Rajah Model Ekonomi Kitaran',
            intro: {
                title: 'Gantikan Kayu dengan Buluh, Berkuasa dengan Hijau',
                content: 'Sebagai Penyokong Pemanfaatan Cekap Sumber Buluh, Kami Membangunkan Model Ekonomi Kitaran "Buluh-Pulpa-Kertas-Tenaga-Baja" Lima dalam Satu, Membolehkan Setiap Batang Buluh Memancarkan Tenaga Hijau'
            },
            items: {
                source: {
                    title: 'Permulaan Hijau: Sumber Buluh Lestari',
                    points: [
                        'Menubuhkan Pangkalan Demonstrasi Buluh Ekologi, Menggunakan Model Pengurusan Tebangan Bergilir',
                        'Buluh Tumbuh Cepat (Matang dalam 3-5 Tahun), Keupayaan Penyerapan Karbon 1.5 Kali Ganda daripada Fir',
                        'Meningkatkan Pendapatan 100,000 Pekebun, Menukar "Gunung Hijau dan Air Jernih" menjadi "Gunung Emas dan Perak"'
                    ]
                },
                core: {
                    title: 'Kitaran Teras: Sifar Pelepasan Tiga Sisa',
                    points: [
                        'Sisa Cecair → Tenaga: Cecair Hitam Pulping 100% Dikitar, Menjana 60 Juta kWh Setahun',
                        'Gas Buang → Sumber: Haba Lebihan Gas Dandang Digunakan Semula, Mengurangkan Pelepasan CO2',
                        'Sisa Pepejal → Sumber Karbon: Serpihan Buluh Dijadikan Bahan Bakar Pelet Biojisim'
                    ]
                },
                upgrade: {
                    title: 'Naik Taraf Produk: Pemanfaatan Buluh Penuh',
                    points: [
                        'Pembungkusan Makanan Pulpa Buluh Premium, Kertas Kegunaan Harian (Bersijil FSC)',
                        'Bahan Pembungkusan Boleh Terurai Gentian Buluh (Pengganti Plastik)',
                        'Serpihan dan Hampar Buluh Diproses Menjadi Bahan Buangan Biojisim'
                    ]
                }
            },
            vision: {
                title: 'Wawasan Kami:',
                content: 'Membolehkan Setiap Batang Buluh Menyelesaikan Perjalanan Hijau dari Karbon ke Produk'
            }
        },
        socialResponsibility: {
            title: 'Tanggungjawab Sosial',
            subtitle: 'Berkebaikan Senyap, Amal Menyeluruh',
            tabs: {
                community: 'Pembangunan Komuniti',
                farmers: 'Meningkatkan Pendapatan Petani',
                education: 'Pembangunan Bakat',
                biodiversity: 'Mesra Alam'
            },
            community: {
                title: 'Rancangan Pembangunan Desa',
                description: 'Yibin Paper Menyokong Strategi Pembangunan Desa Negara melalui Model "Perusahaan + Koperasi + Pekebun", Memacu Pembangunan Industri Buluh di Desa Sekitar, Meningkatkan Daya Hidup Ekonomi Desa',
                items: {
                    village: {
                        title: 'Bantuan Menetap Desa',
                        content: "Syarikat Menghantar 2 Kader Parti sebagai Setiausaha Pertama Menetap Desa di Kampung Shizi, Yongxing, Daerah Cuiping; 1 Kader Parti sebagai Ahli Pasukan Kerja Menetap Desa di Kampung Xingwang, Yangchun, Daerah Jiang'an"
                    },
                    manager: {
                        title: 'Pengurus Profesional Ekonomi Kolektif',
                        content1: 'Menghantar 2 Bakat Teras sebagai "Pengurus Profesional" untuk Mengawal Kewangan Desa, Menyeragamkan Sistem, Mengembangkan Pasaran, Memasarkan Produk dan Melatih Usahawan, Membantu Meningkatkan Piawaian, Pasaran dan Profesionalisme Ekonomi Kolektif Desa',
                    },
                    project: {
                        title: 'Projek Perkongsian Industri Satu-Lawan-Satu Daerah He Miao, Xingwen',
                        content: 'Menurut "Skema Pelaksanaan Mekanisme Perkongsian Satu-Lawan-Satu Perusahaan-Desa Etnik", Syarikat Berhubung dengan Daerah He Miao, Xingwen untuk Menyelesaikan Masalah Penjualan Bahan Buluh'
                    }
                }
            },
            farmers: {
                title: 'Projek Meningkatkan Pendapatan Petani',
                description: 'Kami Menjalin Kerjasama Stabil dengan Pekebun Buluh Tempatan melalui Model Pembelian Langsung, Melabur dalam Peralatan Pintar dan Mempromosikan Pembiakan Saintifik, Membantu Meningkatkan Pendapatan Pekebun dan Mencapai Kemakmuran Bersama',
                imageAlt: 'Projek Meningkatkan Pendapatan Petani',
                items: {
                    direct: {
                        title: 'Pembelian Langsung Mengawal Menghapuskan Orang Tengah, Melindungi Kepentingan Pekebun',
                        content1: 'Memecahkan Model Pembelian Tradisional, Membentuk Pelbagai Model Pembelian Langsung seperti "Perusahaan + Tapak Bahan Koperasi + Pekebun" dan "Perusahaan + Tapak Bahan Sendiri + Pekebun"',
                        content2: 'Mengukuhkan Kerjasama Mendalam Industri Primer-Sekunder, Menghapuskan Orang Tengah, Menggali Potensi Kos Setiap Peringkat, Memastikan Bekalan Bahan Mentah sambil Memudahkan Penjualan Buluh Pekebun, Menstabilkan Harga Buluh, Melindungi Kepentingan Pekebun'
                    },
                    tech: {
                        title: 'Pemberian Kuasa Teknologi untuk Naik Taraf Industri, Meningkatkan Pendapatan Pekebun',
                        content1: 'Meningkatkan Pelaburan dalam Peralatan Pintar, Menyelidik Jentera untuk Menuai dan Mengangkut Buluh',
                        content2: 'Meningkatkan Kecekapan Menuai dan Mengangkut Buluh Secara Menyeluruh, Membebaskan Tenaga Kerja Sepenuhnya, Mengurangkan Kos Menuai, dan Berkongsi Manfaat Teknologi dengan Pekebun, Meningkatkan Pendapatan Pekebun',
                        content3: 'Melalui Demonstrasi Pembiakan, Penanaman dan Pengurusan Saintifik, Mencapai Kesan Demonstrasi Hasil Tinggi Buluh',
                        content4: 'Membimbing Pekebun Menanam Secara Saintifik, Mengurangkan Kos Penanaman dan Pengurusan, Meningkatkan Hasil per Mu, Menambah Pendapatan Pekebun'
                    },
                    value: {
                        title: 'Kerjasama Nilai Tambah Meneroka Saluran, Meningkatkan Pendapatan Menyeluruh',
                        content1: 'Meneroka Model Kerjasama Pelbagai, Mengaktifkan "Pendapatan Bukan Kayu" Buluh, Bekerjasama dengan Pihak Ketiga untuk Perdagangan Karbon Buluh Percubaan, Pekebun Menerima Dividen Tambahan berdasarkan Keberkesanan Pengurusan',
                        content2: 'Serentak Membimbing Pembangunan Tanaman dan Ternakan Bawah Hutan, Meningkatkan Pendapatan Menyeluruh Buluh; Menggabungkan Ekonomi Bawah Hutan dengan Pengurusan Karbon, Meningkatkan Keupayaan Penyerapan Karbon Buluh, Menambah Pendapatan Pekebun, Mencapai Kemenangan "Ekologi + Ekonomi"'
                    }
                }
            },
            education: {
                title: 'Program Pembangunan Bakat Buluh',
                description: 'Bakat adalah Enjin Teras Pembangunan. Kami Menghargai Pembangunan Bakat, melalui Pembinaan Mekanisma Pembangunan Bakat Pelbagai, Melatih Bakat Industri Masa Depan',
                imageAlt: 'Program Pembangunan Bakat',
                items: {
                    mechanism: {
                        title: 'Mekanisma Pembangunan Bakat Pelbagai',
                        content: 'Melalui Mekanisma "Mentor-Pelajar", Simpanan Bakat Sandaran, Amalan Rotasi Kerja dan Kursus Latihan Tersuai, Membantu Pekerja Bertransformasi daripada Pendatang Baru kepada Elit Industri'
                    },
                    path: {
                        title: 'Laluan Pembangunan Sempurna',
                        content: 'Saluran Kenaikan Pangkat dan Laluan Pembangunan Pelbagai yang Sentiasa Disempurnakan, Membolehkan Setiap Ahli Bersinar dalam Bidang Kepakaran, Menyertai Syarikat dalam Perjalanan Pertumbuhan Baharu'
                    }
                }
            },
            biodiversity: {
                title: 'Rancangan Kilang Hijau',
                description: 'Kami Menyokong Sasaran "Dual Karbon" Negara, Mengambil Pembangunan Lestari sebagai Fokus Strategik, Sentiasa Mengoptimumkan Sistem Pengurusan Alam Sekitar',
                imageAlt: 'Projek Mesra Alam',
                items: {
                    policy: {
                        title: 'Gantikan Kayu dengan Buluh "Gantikan Plastik dengan Buluh"',
                        content: 'Menyokong Dasar Kerajaan "Gantikan Kayu dengan Buluh" dan "Gantikan Plastik dengan Buluh", Mengurangkan Kesan Pengeluaran terhadap Sumber Semula Jadi, Beralih ke Ekonomi Karbon Rendah, Mencapai Kemenangan Ekonomi dan Alam Sekitar'
                    },
                    factory: {
                        title: 'Kilang Hijau',
                        content: 'Telah Lulus Pensijilan Hutan FSCFM/CoC, Dinobat sebagai Perusahaan "Kilang Hijau" Peringkat Negara dan "Pengeluaran Bersih" Sichuan, Produk Memenangi "Anugerah Produk Cemerlang Jenama Jimat Tenaga & Alam Sekitar Sichuan"'
                    }
                }
            }
        },
        report: {
            title: 'Laporan Pembangunan Lestari',
            subtitle: 'Pendedahan Maklumat Pembangunan Lestari Telus, Benar dan Menyeluruh',
            download: 'Muat Turun Laporan',
            items: {
                '2024': {
                    title: 'Laporan Pembangunan Lestari 2024',
                    date: 'Tarikh Terbit: April 2024',
                    imageAlt: 'Laporan Pembangunan Lestari 2024'
                },
                '2023': {
                    title: 'Laporan Pembangunan Lestari 2023',
                    date: 'Tarikh Terbit: April 2023',
                    imageAlt: 'Laporan Pembangunan Lestari 2023'
                }
            }
        },
        cta: {
            title: 'Bersama Kami, Membina Masa Depan Lestari',
            description: 'Ketahui Lebih Lanjut Amalan Pembangunan Lestari Yibin Paper, atau Bekerjasama dengan Kami Memacu Pembangunan Hijau',
            buttonText: 'Hubungi Kami'
        }
    },
    home: {
        advantages: {
            title: "Keunggulan Kami",
            subtitle: "Pembuatan Kertas Buluh, Teknologi Mesra Alam, Kualiti Unggul",
            items: {
                experience: {
                    title: "Pengalaman Industri yang Mendalam",
                    description: "80 Tahun Pengalaman Teknikal, Rantaian Industri Penuh Bersepadu, Menyokong Transformasi Bahan Bio-Berasaskan Karbon Rendah."
                },
                production: {
                    title: "Sistem Pengeluaran Skala Besar Matang",
                    description: "Kemudahan Pengeluaran & Talian Automasi Lengkap, Responsif terhadap Keperluan Pelanggan, Pengeluaran Berkos Rendah & Berkecekapan Tinggi."
                },
                innovation: {
                    title: "Kerjasama Penyelidikan Industri-Akademi",
                    description: "Makmal Bersama dengan Institusi Pengajian Tinggi, Fokus pada Teknologi Karbon Rendah & Bahan Boleh Diperbaharui, Mempercepat Pengkomersialan Teknologi Bio-Berasaskan."
                },
                certification: {
                    title: "Pensijilan Hijau Rantaian Penuh",
                    description: "Pensijilan FSC, Gred Perubatan, Keselamatan Kesihatan dari Sumber hingga Produk, Meningkatkan Daya Saing Pasaran."
                }
            }
        },
        products: {
            title: "Produk Utama",
            subtitle: "Produk Kertas Pulpa Buluh Premium, Memenuhi Kepelbagaian Keperluan",
            items: {
                bambooPulp: {
                    title: "Pulpa Buluh Asli",
                    description: "Spesies Buluh Terpilih, Gentian Berkualiti Tinggi",
                    alt: "Pulpa Buluh"
                },
                packagingPaper: {
                    title: "Kertas Pembungkusan Pulpa Buluh Asli",
                    description: "Kekuatan Baik, Ketahanan Lipatan Tinggi, Kebersihan Tinggi",
                    alt: "Kertas Pembungkusan"
                },
                culturalPaper: {
                    title: "Kertas Budaya Pulpa Buluh Asli",
                    description: "Licin dan Halus, Pengalaman Menulis dan Mencetak Unggul",
                    alt: "Kertas Budaya"
                },
                livingPaper: {
                    title: "Kertas Asas Kegunaan Harian Pulpa Buluh Asli",
                    description: "Kuat Semasa Basah, Hijau dan Mesra Alam",
                    alt: "Kertas Asas Kegunaan Harian"
                },
                finishedPaper: {
                    title: "Kertas Siap Kegunaan Harian Pulpa Buluh Asli",
                    description: "Lentur dan Selesa, Sihat dan Antibakteria",
                    alt: "Kertas Siap Kegunaan Harian"
                },
                fiberMaterial: {
                    title: "Bahan Gentian",
                    description: "Fungsi Pelbagai, Sesuai untuk Pelbagai Keperluan Khas",
                    alt: "Bahan Gentian"
                },
                learnMore: "Ketahui Lebih Lanjut"
            }
        },
        about: {
            title: "Mengenai Yibin Paper",
            description1: "Yibin Paper Industry Co., Ltd. Diasaskan pada 1944, Pengeluar Terkemuka Kertas Pulpa Buluh China, Menumpukan pada Penyelidikan dan Pengeluaran Pulpa dan Kertas Buluh",
            description2: "Syarikat Berada di Yibin, Sichuan, Memiliki Sumber Buluh Kaya dan Peralatan Pengeluaran Maju, Kapasiti Tahunan Melebihi 500,000 Tan Kertas Pulpa Buluh Berkualiti Tinggi",
            description3: "Kami Berusaha Menyediakan Produk Kertas Berkualiti dan Mesra Alam melalui Inovasi Teknologi dan Pengeluaran Hijau, Serentak Memacu Pembangunan Lestari Industri Kertas",
            learnMore: "Ketahui Lebih Lanjut"
        },
        sustainability: {
            title: "Pembangunan Lestari",
            subtitle: "Pembuatan Kertas Pulpa Buluh, Kitaran Hijau",
            items: {
                renewable: {
                    title: "Sumber Buluh Boleh Diperbaharui",
                    description: "Buluh Matang dalam 3-5 Tahun, Tumbuh Cepat, Bahan Kertas Boleh Diperbaharui Ideal"
                },
                carbon: {
                    title: "Sumbangan Karbon",
                    description: "Buluh Menyerap Lebih CO₂ daripada Hutan Luas Sama, Melambatkan Perubahan Iklim dengan Berkesan"
                },
                clean: {
                    title: "Pengeluaran Bersih",
                    description: "Menggunakan Proses Pengeluaran Kitaran Tertutup, Mengitar Semula Air Sisa Terawat, Mencapai Jimat Tenaga dan Kurangkan Pelepasan"
                },
                rural: {
                    title: "Pembangunan Desa",
                    description: "Meningkatkan Pendapatan Pekebun Buluh, Memacu Pembangunan Ekonomi Tempatan, Mencapai Kemenangan Ekologi dan Ekonomi"
                }
            }
        },
        cta: {
            title: "Bekerjasama dengan Kami, Membina Masa Depan Hijau",
            description: "Kami Berharap Menyediakan Produk Kertas Pulpa Buluh Berkualiti dan Perkhidmatan Profesional",
            buttonText: "Hubungi Kami"
        }
    },
    contact: {
        banner: {
            title: 'Hubungi Kami',
            subtitle: 'Sentiasa Mengalu-alukan Pertanyaan dan Maklum Balas Anda'
        },
        contactInfo: {
            title: 'Maklumat Perhubungan',
            subtitle: 'Sentiasa Mengalu-alukan Pertanyaan dan Maklum Balas Anda',
            address: {
                title: 'Alamat Syarikat',
                content: 'Kawasan Perindustrian Ringan Peishi, Daerah Nanxi, Yibin, Sichuan',
                postcode: 'Poskod: 644100'
            },
            phone: {
                title: 'Perundingan Telefon',
                main: 'Talian Am: 0831-3309663',
                service: 'Talian Khidmat Pelanggan: 0831-3309698'
            },
            email: {
                title: 'E-mel',
                service: 'Khidmat Pelanggan: ybzy@yb-zy.com',
                inquiry: 'Perundingan Produk: ybzy@yb-zy.com'
            },
            workingHours: {
                title: 'Waktu Operasi',
                weekday: 'Isnin hingga Jumaat: 9:00 - 17:30',
                holiday: 'Cuti pada Hari Kelepasan Undang-undang'
            }
        },
        inquiry: {
            title: 'Perundingan Dalam Talian',
            subtitle: 'Isi Borang di Bawah, Kami Akan Menghubungi Anda Secepat Mungkin',
            form: {
                name: 'Nama Anda',
                company: 'Nama Syarikat',
                email: 'E-mel',
                phone: 'Nombor Telefon',
                subject: 'Subjek Perundingan',
                subjectPlaceholder: 'Sila Pilih Subjek Perundingan',
                subjects: {
                    product: 'Perundingan Produk',
                    price: 'Perundingan Sebut Harga',
                    technical: 'Sokongan Teknikal',
                    cooperation: 'Perbincangan Kerjasama',
                    other: 'Isu Lain'
                },
                message: 'Kandungan Perundingan',
                submit: 'Hantar Maklumat',
                submitting: 'Sedang Menghantar...'
            },
            sales: {
                title: 'Perkhidmatan Jualan',
                domesticRawPaper: 'Jualan Domestik (Kertas Asas)',
                domesticFinishedPaper: 'Jualan Domestik (Kertas Siap)',
                international: 'Jualan Antarabangsa',
                email: 'E-mel Jualan'
            },
            afterSales: {
                title: 'Perkhidmatan Selepas Jualan',
                hotlineRawPaper: 'Talian Khidmat (Kertas Asas)',
                hotlineFinishedPaper: 'Talian Khidmat (Kertas Siap)',
                email: 'E-mel Khidmat'
            },
            social: {
                title: 'Ikuti Kami',
                wechat: 'WeChat Rasmi',
                weibo: 'Weibo Rasmi',
                linkedin: 'LinkedIn'
            }
        },
        location: {
            title: 'Lokasi Syarikat',
            subtitle: 'Dialu-alukan untuk Lawatan dan Pemeriksaan',
            mapAlt: 'Lokasi Peta Yibin Paper Industry Co., Ltd.',
            transport: {
                public: {
                    title: 'Pengangkutan Awam',
                    content: 'Bas: Naik Laluan Nanxi 10 [Zhongba] ke "Stesen Yibin Paper"'
                },
                driving: {
                    title: 'Pemanduan Kenderaan Sendiri',
                    content: 'Navigasi ke "Yibin Paper Industry Co., Ltd.", Syarikat Menyediakan Tempat Letak Kereta Pelawat'
                },
                airport: {
                    title: 'Pengangkutan Lapangan Terbang',
                    content: 'Lapangan Terbang Wuliangye Yibin Kira-kira 58km dari Syarikat, Boleh Naik Bas Lapangan Terbang atau Teksi'
                }
            }
        },
        offices: {
            title: '全球办事处',
            subtitle: '国际化服务网络',
            china: {
                title: '中国总部',
                flagAlt: '中国国旗',
                address: '四川省宜宾市翠屏区岷江西路159号',
                phone: '电话：0831-12345678'
            },
            usa: {
                title: '北美代表处',
                flagAlt: '美国国旗',
                address: '美国加利福尼亚州洛杉矶市橡树大道2588号',
                phone: '电话：+1-213-888-9999'
            },
            japan: {
                title: '日本代表处',
                flagAlt: '日本国旗',
                address: '日本东京都千代田区丸之内1-2-3',
                phone: '电话：+81-3-1234-5678'
            },
            europe: {
                title: '欧洲代表处',
                flagAlt: '德国国旗',
                address: '德国汉堡市汉萨街456号',
                phone: '电话：+49-40-8765-4321'
            },
            singapore: {
                title: '东南亚代表处',
                flagAlt: '新加坡国旗',
                address: '新加坡莱佛士码头10号',
                phone: '电话：+65-6789-0123'
            }
        },
        faq: {
            title: 'Soalan Lazim',
            subtitle: 'Jawapan Pantas untuk Persoalan Anda'
        },
        cta: {
            title: 'Menantikan Komunikasi dengan Anda',
            description: 'Tidak Kira Apa Masalah atau Keperluan Anda, Kami Akan Berkhidmat Sepenuh Hati',
            buttonText: 'Berunding Sekarang'
        }
    }
} 